export default __webpack_public_path__ + "static/media/guy-with-mag-glass.d4ed1b1a.svg";